import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './common/SafeIcon';

const { FiEdit2, FiTrash2, FiEye, FiImage, FiMapPin, FiPackage, FiZap } = FiIcons;

const InventoryCard = ({ item, categoryKey, onDelete }) => {
  const navigate = useNavigate();
  const formatCurrency = (val) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(val || 0);

  return (
    <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-sm border border-slate-200 dark:border-slate-800 overflow-hidden group hover:shadow-xl transition-all duration-300 flex flex-col">
      {/* Image Section */}
      <div className="relative aspect-video bg-slate-100 dark:bg-slate-800 overflow-hidden">
        {item.images && item.images.length > 0 ? (
          <img 
            src={item.images[0]} 
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" 
            alt={item.name} 
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-slate-300 dark:text-slate-700">
            <SafeIcon icon={FiImage} className="text-5xl" />
          </div>
        )}
        <div className="absolute top-3 left-3">
          <span className="px-2 py-1 rounded-md text-[10px] font-black uppercase bg-white/90 dark:bg-slate-900/90 text-slate-800 dark:text-white shadow-sm">
            {item.inventory_id}
          </span>
        </div>
        <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity flex gap-1">
          <button 
            onClick={() => navigate(`/inventory/${categoryKey}/${item.id}/details`)}
            className="p-2 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 rounded-lg shadow-lg hover:text-yellow-600"
          >
            <SafeIcon icon={FiEye} size={14} />
          </button>
        </div>
      </div>

      {/* Content Section */}
      <div className="p-5 flex-1 flex flex-col">
        <div className="mb-4">
          <p style={{
      color: 'rgb(235, 5, 5)'
    }} className="text-[10px] font-bold text-yellow-600 dark:text-yellow-500 uppercase tracking-widest mb-1">
            {item.manufacturer}
          </p>
          <h3 className="font-bold text-slate-900 dark:text-white leading-tight line-clamp-1">
            {item.name || item.article_number}
          </h3>
          <p className="text-xs text-slate-500 dark:text-slate-400 font-mono mt-1">
            Art-Nr: {item.article_number}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 mb-4">
          <div className="flex items-center gap-2 text-[10px] text-slate-500 dark:text-slate-400 font-bold uppercase">
            <SafeIcon icon={FiMapPin} className="text-yellow-500" />
            <span className="truncate">{item.location || '-'}</span>
          </div>
          <div className="flex items-center gap-2 text-[10px] text-slate-500 dark:text-slate-400 font-bold uppercase">
            <SafeIcon icon={FiPackage} className="text-blue-500" />
            <span>{item.condition || '-'}</span>
          </div>
        </div>

        <div className="mt-auto pt-4 border-t border-slate-100 dark:border-slate-800 flex items-center justify-between">
          <div className="text-lg font-black text-slate-900 dark:text-white">
            {formatCurrency(item.total_value)}
          </div>
          <div className="flex gap-1">
            <button 
              onClick={() => navigate(`/inventory/${categoryKey}/${item.id}`)}
              className="p-2 text-slate-400 hover:text-blue-500 hover:bg-blue-50 dark:hover:bg-blue-500/10 rounded-lg transition-colors"
            >
              <SafeIcon icon={FiEdit2} size={14} />
            </button>
            <button 
              onClick={() => onDelete(item.id)}
              className="p-2 text-slate-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10 rounded-lg transition-colors"
            >
              <SafeIcon icon={FiTrash2} size={14} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InventoryCard;